import React, { Component } from 'react';
import { Col, Row } from 'antd';
import { FormattedMessage, injectIntl, FormattedHTMLMessage } from 'react-intl';
import messages from './messages';
import Button from '../Button/index';
import Wrapper from '../LandingBlockWrapper/BlockWrapper';
import popup from '../../actions/popup';

class Home extends Component {
	render() {
		const { intl: { formatMessage } } = this.props;
		return (
			<Wrapper className='Home'>
				<Row>
					<Col>
						<h2>{formatMessage(messages.title)}</h2>
					</Col>
				</Row>
				<Row>
					<Col>
						<p><FormattedHTMLMessage {...messages.subtitle} /></p>
					</Col>
				</Row>
				<Row type='flex' justify='center' className="buttonItems">
					<Col xs={24} sm={24} md={12}>
						<Button onClick={() => popup.show(null, 'Buy')}>
							<FormattedMessage {...messages.buttonBuy} />
						</Button>
					</Col>
				</Row>
			</Wrapper>
		);
	}
};

export default injectIntl(Home);




// WEBPACK FOOTER //
// ./src/components/LandingHome/Home.js